import React from 'react';
import MaskedInput from 'react-text-mask';
import mask from '../utils/mask';

export const CPF_MASK =
  mask([/\d/, 3], '.', [/\d/, 3], '.', [/\d/, 3], '-', [/\d/, 2]);

export const CNPJ_MASK =
  mask(
    [/[A-Za-z0-9]/, 2], '.',
    [/[A-Za-z0-9]/, 3], '.',
    [/[A-Za-z0-9]/, 3], '/',
    [/[A-Za-z0-9]/, 4], '-',
    [/\d/, 2]
  );

const applyDynamicMask = v => v.replace(/[^A-Za-z0-9]/g, '').length < 12 ? CPF_MASK : CNPJ_MASK;

export default function DocumentInput(props) {
  const {
    inputRef,
    dynamicMask,
    mask = dynamicMask ? applyDynamicMask : CPF_MASK,
    ...rest
  } = props;

  return <MaskedInput {...rest} ref={inputRef} mask={mask} />;
}
